module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAvCAMAAAAo/zGbAAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMA7jBIGvr1PMaM4WYTqaF1MwzourKFbQh9KSUemVBgCuI2AAAAuUlEQVQ4y+3SzRKCMAwE4PJXKFooCAVE8/6PKY5O0pmEnD24128Wtp2aT0qjpF41rNo4nCMAuEFBGC8iFge+Y5007cBvekEn1La/Mg0NYGZevncW28K08kZtxz9eTzjNRt5ePJbHueTtZNoq/DuZFhe+vFGnBY/tTDjYMAGy06f1QrtT7zxP75wv3+hgo37nldsY70Dh7UCYsWFFgvkffwSfGhoVjZeR3iEhz/6whOI7JOQJHlHMCb4AfSwww611uY8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/index/check_arrow.png
// module id = zhGj
// module chunks = 1